import React, { useRef, useState } from 'react';
import { debounce } from 'debounce';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import CourtPicker from '../timesheets/CourtPicker';

const CourtDetails = ({ court, caseNumber, onChange, onCaseNumberChange }) => {
    const [costCentre, setCostCentre] = useState(court?.costCentre);

    const caseNumberRef = useRef(caseNumber);

    const handleCourtChange = updated => {
        setCostCentre(updated?.costCentre);
        onChange(updated);
    }

    const handleCaseNumberChange = debounce(() => {
        const { value = '' } = caseNumberRef.current || {};
        onCaseNumberChange(value);
    }, 500);

    return (
        <Paper style={{ padding: '1rem' }}>
            <Typography variant="h6" color="initial" >Court Details</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4} lg={4}>
                    <CourtPicker onChange={handleCourtChange} court={court} />
                </Grid>
                <Grid item xs={12} md={4} lg={2}>
                    <TextField
                        disabled
                        value={costCentre || ''}
                        label="Cost Code"
                        helperText=""
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <TextField
                        inputRef={caseNumberRef}
                        defaultValue={caseNumber}
                        onChange={handleCaseNumberChange}
                        label="Case Number"
                        helperText="Edit if the case number is incorrect"
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default CourtDetails;